import withStyles from '@material-ui/core/styles/withStyles'

export default withStyles(theme => {
  return {
    box: {
      width: '100%',
      borderRadius: 32,
    },
  }
})
